module.exports = __webpack_public_path__ + "img/logo.c0d7086b.jpeg";